import { Navigate, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { POST_LOSS_ROUTES, UPGRADE_SEARCH_PARAM } from "@/shared/constants/paths";

// Post Loss App Pages
import { OverviewPage } from "@/pages/postloss/overview/OverviewPage";
import { SummaryPage } from "@/pages/postloss/summary/SummaryPage";
import { DocumentsPage } from "@/pages/postloss/documents/DocumentsPage";
import PeoplePage from "@/pages/postloss/people/PeoplePage";
import { ResourcesPage } from "@/pages/postloss/resources/ResourcesPage";
import ArticlePage from "@/pages/postloss/resources/article/ArticlePage";
import SettingsPage from "@/pages/postloss/settings/SettingsPage";
import { ModulePage } from "@/pages/postloss/modules/ModulePage";
import { EstateInventoryPage } from "@/pages/postloss/estate-inventory/EstateInventoryPage";
import { EstateEssentialsPage } from "@/pages/postloss/estate-essentials/EstateEssentialsPage";
import { ModuleDetailPage } from "@/pages/postloss/estate-essentials/ModuleDetailPage";
import { FindAssetsPage } from "@/pages/postloss/find-assets/FindAssetsPage";
import { GetAuthorizedPage } from "@/pages/postloss/get-authorized/GetAuthorizedPage";
import { SettleEstatePage } from "@/pages/postloss/settle-estate/SettleEstatePage";

export const postLossRoutes = (
  <>
    <Route
      path={POST_LOSS_ROUTES.OVERVIEW}
      element={
        <>
          <Helmet>
            <title>Home - Elayne</title>
          </Helmet>
          <OverviewPage />
        </>
      }
    />
    <Route
      path={POST_LOSS_ROUTES.SUMMARY}
      element={
        <>
          <Helmet>
            <title>Summary - Elayne</title>
          </Helmet>
          <SummaryPage />
        </>
      }
    />
    <Route
      path={POST_LOSS_ROUTES.DOCUMENTS}
      element={
        <>
          <Helmet>
            <title>Documents - Managing Loss</title>
          </Helmet>
          <DocumentsPage />
        </>
      }
    />
    <Route
      path={POST_LOSS_ROUTES.CONTACTS}
      element={
        <>
          <Helmet>
            <title>People - Managing Loss</title>
          </Helmet>
          <PeoplePage />
        </>
      }
    />
    <Route
      path={POST_LOSS_ROUTES.RESOURCES}
      element={
        <>
          <Helmet>
            <title>Resources - Managing Loss</title>
          </Helmet>
          <ResourcesPage />
        </>
      }
    />
    <Route
      path={POST_LOSS_ROUTES.RESOURCES_ARTICLE}
      element={
        <>
          <Helmet>
            <title>Blog Article - Managing Loss</title>
          </Helmet>
          <ArticlePage />
        </>
      }
    />
    <Route
      path={POST_LOSS_ROUTES.SETTINGS}
      element={
        <>
          <Helmet>
            <title>Settings - Elayne</title>
          </Helmet>
          <SettingsPage />
        </>
      }
    />
    <Route
      path={POST_LOSS_ROUTES.ESTATE_INVENTORY}
      element={
        <>
          <Helmet>
            <title>Assets & Debts - Elayne</title>
          </Helmet>
          <EstateInventoryPage />
        </>
      }
    />
    <Route
      path={POST_LOSS_ROUTES.ESTATE_ESSENTIALS}
      element={
        <>
          <Helmet>
            <title>Important to-dos - Elayne</title>
          </Helmet>
          <EstateEssentialsPage />
        </>
      }
    />
    <Route
      path={POST_LOSS_ROUTES.ESTATE_ESSENTIALS_MODULE}
      element={
        <>
          <Helmet>
            <title>Important to-dos - Elayne</title>
          </Helmet>
          <ModuleDetailPage />
        </>
      }
    />
    <Route
      path={POST_LOSS_ROUTES.FIND_ASSETS}
      element={
        <>
          <Helmet>
            <title>Find assets - Elayne</title>
          </Helmet>
          <FindAssetsPage />
        </>
      }
    />
    <Route
      path={POST_LOSS_ROUTES.GET_AUTHORIZED}
      element={
        <>
          <Helmet>
            <title>Get Authorized - Elayne</title>
          </Helmet>
          <GetAuthorizedPage />
        </>
      }
    />
    <Route
      path={POST_LOSS_ROUTES.SETTLE_ESTATE}
      element={
        <>
          <Helmet>
            <title>Settle the Estate - Elayne</title>
          </Helmet>
          <SettleEstatePage />
        </>
      }
    />
    <Route
      path="/close-estate"
      element={<Navigate to={POST_LOSS_ROUTES.SETTLE_ESTATE} replace />}
    />
    <Route
      path={POST_LOSS_ROUTES.UPGRADE}
      element={
        <Navigate to={`${POST_LOSS_ROUTES.OVERVIEW}?${UPGRADE_SEARCH_PARAM}=true`} replace />
      }
    />
    <Route path="/profile" element={<Navigate to={POST_LOSS_ROUTES.SUMMARY} replace />} />
    <Route path={POST_LOSS_ROUTES.MODULE} element={<ModulePage />} />
  </>
);
